import {Injectable} from '@angular/core';
import {SearchTicket, TicketDetail, TicketService as Api} from '../../generated/sales-terminal-client';
import {SnackService} from '../snack/snack.service';
import {Observable, tap} from 'rxjs';
import {PageableResult} from '../../components/scroll-load-component/scroll-load.component';
import {TicketsSearchFilters} from '../../modules/sales-terminal/tickets/tickets.component';
import {AuthService} from '../auth/auth.service';
import {LanguageService} from '../language/language.service';

@Injectable({
  providedIn: 'root'
})
export class TicketsService {

  constructor(private api: Api,
              private snackService: SnackService,
              private languageService: LanguageService) {}

  public getTicketList(filters: TicketsSearchFilters): Observable<PageableResult<SearchTicket>> {
    return this.api.ticketsGet(
      filters.page,
      filters.pageSize,
      filters.sortOrder,
      filters.dateStart,
      filters.dateEnd,
      filters.salespointId,
      filters.ticketId,
      filters.barcode,
      filters.invoiceNumber,
      filters.eventId,
      filters.customerEmail,
      filters.customerUuid
    ).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) })
    );
  }

  public getTicketListCsv(filters: TicketsSearchFilters): Observable<string> {
    return this.api.ticketsCsvGet(
      this.languageService.selectedLang,
      filters.dateStart,
      filters.dateEnd,
      filters.salespointId,
      filters.ticketId,
      filters.barcode,
      filters.invoiceNumber,
      filters.eventId,
      filters.customerEmail,
      filters.customerUuid,
      'body', false, {httpHeaderAccept: 'text/csv'}
    ).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) })
    );
  }

  public getTicket(ticketId: number): Observable<TicketDetail> {
    return this.api.ticketIdGet(ticketId).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) })
    );
  }
}
